import { PREMIUM_SIZES } from '../utils/pergolaCatalog';
import React, { useEffect } from 'react';
import Navigation from '../components/Navigation';
import PergolasHeroSection from '../components/pergolas/PergolasHeroSection';
import PergolasProductShowcase from '../components/pergolas/PergolasProductShowcase';
import PergolasFeatures from '../components/pergolas/PergolasFeatures';
import PergolasProjects from '../components/pergolas/PergolasProjects';
import PergolasWorkShowcase from '../components/pergolas/PergolasWorkShowcase';
import PergolasFAQ from '../components/pergolas/PergolasFAQ';
import CTASection from '../components/CTASection';
import Footer from '../components/Footer';
import PromotionBanner from '../components/PromotionBanner';

const PergolasPage: React.FC = () => {
  useEffect(() => {
    // Google Analytics
    const script1 = document.createElement('script');
    script1.async = true;
    script1.src = 'https://www.googletagmanager.com/gtag/js?id=G-SDHCNDS5MG';
    document.head.appendChild(script1);

    const script2 = document.createElement('script');
    script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-SDHCNDS5MG');
    `;
    document.head.appendChild(script2);

    // Set document title and meta tags
    document.title = 'Premium & Premium+ Pergolas Ontario | Evie Outdoors';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Luxury pergolas built for Canadian winters. Maintenance-free shade, all year long. Premium motorized pergolas with instant estimates and Premium+ by individual quote. Professional installation across Ontario.');
    }

    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'Toronto pergolas, Ontario pergola installers, louvered pergolas Canada, motorized pergola Toronto, pergola installation Ontario, aluminum pergola Toronto, outdoor living Ontario, pergola contractors Toronto, premium pergolas Ontario, Premium Plus pergola Canada');
    }

    // Add structured data for SEO
    const structuredData = document.createElement('script');
    structuredData.type = 'application/ld+json';
    structuredData.innerHTML = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Product",
      "name": "Premium Pergolas",
      "description": "Luxury pergolas built for Canadian winters with professional installation across Ontario",
      "image": [
        "https://evieoutdoors.com/images/pergolas/automatic-louvered-roof-pergolabd38e76f-c028-4071-b220-775b3a66a112.webp",
        "https://evieoutdoors.com/images/pergolas/garden-freestanding-pergola-on-deck36558321685.webp",
        "https://evieoutdoors.com/images/pergolas/outdoor-garden-manual-aluminium-pergola09366690611.webp"
      ],
      "brand": {
        "@type": "Brand",
        "name": "Evie Outdoors"
      },
      "offers": {
        "@type": "Offer",
        "price": PREMIUM_SIZES[0].priceCAD,
        "priceCurrency": "CAD",
        "availability": "https://schema.org/InStock",
        "shippingDetails": {
          "@type": "OfferShippingDetails",
          "shippingRate": {
            "@type": "MonetaryAmount",
            "value": "0",
            "currency": "CAD"
          },
          "deliveryTime": {
            "@type": "ShippingDeliveryTime",
            "handlingTime": {
              "@type": "QuantitativeValue",
              "minValue": 7,
              "maxValue": 14,
              "unitCode": "DAY"
            },
            "transitTime": {
              "@type": "QuantitativeValue",
              "minValue": 1,
              "maxValue": 1,
              "unitCode": "DAY"
            }
          },
          "shippingDestination": {
            "@type": "DefinedRegion",
            "addressCountry": "CA",
            "addressRegion": "ON"
          }
        },
        "hasMerchantReturnPolicy": {
          "@type": "MerchantReturnPolicy",
          "applicableCountry": "CA",
          "returnPolicyCategory": "https://schema.org/MerchantReturnFiniteReturnWindow",
          "merchantReturnDays": 30,
          "returnMethod": "https://schema.org/ReturnByMail",
          "returnFees": "https://schema.org/FreeReturn"
        }
      },
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.9",
        "reviewCount": "47"
      }
    });
    document.head.appendChild(structuredData);

    // Cleanup function
    return () => {
      document.head.removeChild(script1);
      document.head.removeChild(script2);
      document.head.removeChild(structuredData);
    };
  }, []);

  return (
    <div className="bg-white">
      <PromotionBanner />
      <Navigation />
      <PergolasHeroSection />
      <PergolasProductShowcase />
      <PergolasFeatures />
      <PergolasProjects />
      <PergolasWorkShowcase />
      <PergolasFAQ />
      <CTASection />
      <Footer />
    </div>
  );
};

export default PergolasPage;
